import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/exam-schedules', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/exam-schedules', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/exam-schedules/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/exam-schedules/${data.exam_sch_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/exam-schedules/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const mainProgram = (Options = {}) => {
  return httpClient
    .get('/api/exam-schedules/get/main-programs', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getSubProgram = (acp_id, Options = {}) => {
  return httpClient
    .get(`/api/exam-schedules/${acp_id}/sub-programs`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  mainProgram,
  getSubProgram
}
